import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

Vue.use(VueI18n)

// 检测浏览器语言
function getBrowserLanguage() {
    const lang = navigator.language || navigator.userLanguage
    // 支持的语言列表
    const supportedLanguages = ['zh-CN', 'zh', 'en-US', 'en']

    // 检查是否为中文
    if (lang.includes('zh')) {
        // return 'en-US'
        return 'zh-CN'
    }

    // 检查是否为英文
    if (lang.includes('en')) {
        return 'en-US'
    }

    // 默认语言为英文
    return 'en-US'
}
console.log(getBrowserLanguage(), '---')
// 创建i18n实例
const i18n = new VueI18n({
    locale: getBrowserLanguage(), // 设置默认语言
    fallbackLocale: 'en-US',      // 回退语言
    messages: {
        'zh-CN': zhCN,
        'en-US': enUS
    },
    silentTranslationWarn: true   // 关闭翻译警告
})

export default i18n